import React from "react";

const HeroFeaturedCard = ({ feature, isLast }) => {
  const { icon: Icon, title, desc, iconColor } = feature;

  return (
    <div className="relative flex flex-col items-center text-center !px-6 !py-5">
      {!isLast && (
        <div
          className="absolute right-0 top-1/2 -translate-y-1/2 h-[140px] w-[1px] hidden md:block lg:hidden xl:hidden 2xl:block bg-border-primary/20 dark:bg-white/10"
        ></div>
      )}

      <div className="!mb-5 flex items-center justify-center" style={{ color: iconColor }}>
        <img src={Icon} alt={title} className="w-auto h-10 lg:h-12 object-contain" />
      </div>

      <h3 className="text-text-primary text-[13px] 2xl:text-[16px] md:text-[14px] font-medium leading-tight !mb-3">{title}</h3>

      {/* <p className="text-text-secondary text-[13px] lg:text-[17px] md:text-[14px] leading-[1.2] max-w-[240px]">{desc}</p> */}
    </div>
  );
};

export default HeroFeaturedCard;
